import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useStore } from '@/context/StoreContext';
import { toast } from 'sonner';
import { Heart } from 'lucide-react';

/** Bookmark a bottle into the customer's private cellar (wishlist). */
export const WishlistButton = ({ product, className = '', variant = 'icon' }) => {
  const { t, inWishlist, toggleWishlist } = useStore();
  const navigate = useNavigate();
  const location = useLocation();
  const saved = inWishlist(product.id);

  const onClick = async (e) => {
    e.preventDefault(); e.stopPropagation();
    const res = await toggleWishlist(product);
    if (res === 'auth_required') {
      toast(t.product.signInToSave, {
        action: { label: t.account.signInBtn, onClick: () => navigate(`/account/login?next=${encodeURIComponent(location.pathname)}`) },
      });
    } else if (res === 'added') toast.success(t.product.savedCellar);
  };

  if (variant === 'button') {
    return (
      <button type="button" data-testid={`wishlist-toggle-${product.reference_id}`} onClick={onClick} aria-pressed={saved}
        className={`inline-flex items-center justify-center gap-2 h-12 px-5 rounded-[3px] border text-[12px] tracking-wide2 uppercase transition-colors duration-300 ${saved ? 'border-nw-gold text-nw-gold' : 'border-nw-gold/40 text-nw-ivory hover:border-nw-gold hover:text-nw-gold'} ${className}`}>
        <Heart size={16} className={saved ? 'fill-nw-gold' : ''} /> {saved ? t.product.savedCellar : t.product.saveCellar}
      </button>
    );
  }
  return (
    <button type="button" data-testid={`wishlist-toggle-${product.reference_id}`} onClick={onClick} aria-pressed={saved}
      aria-label={saved ? t.product.removeCellar : t.product.saveCellar}
      className={`w-9 h-9 rounded-full bg-nw-black/60 backdrop-blur-sm border border-nw-gold/30 flex items-center justify-center transition-colors duration-200 hover:border-nw-gold ${saved ? 'text-nw-gold' : 'text-nw-ivory/80 hover:text-nw-gold'} ${className}`}>
      <Heart size={15} className={saved ? 'fill-nw-gold' : ''} />
    </button>
  );
};
